<template>
  <div>
    <div id="app">
      <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

export default {
  name: 'App',
  // async beforeCreate () {
  //   console.log(`${process.env.VUE_APP_API_BASEURL}/survey/${this.$router.params.qId}/${this.$router.params.lang}`)
  //   this.axios
  //     .get(`${process.env.VUE_APP_API_BASEURL}/survey/${this.$router.params.qId}/${this.$router.params.lang}`)
  //     .then( response => (this.survey = response.data))
  // },
}
</script>

<style>
@import './assets/styles/style.css';
@import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro');
</style>
